/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    BusinessServiceAvailability,
    BusinessServiceAvailabilityFromJSON,
    BusinessServiceAvailabilityFromJSONTyped,
    BusinessServiceAvailabilityToJSON,
    MenuCustomization,
    MenuCustomizationFromJSON,
    MenuCustomizationFromJSONTyped,
    MenuCustomizationToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Represents a single item in the menu.
 * @export
 * @interface MenuItem
 */
export interface MenuItem {
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    category: string;
    /**
     * 
     * @type {Array<Asset>}
     * @memberof MenuItem
     */
    images?: Array<Asset>;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    price: number;
    /**
     * Sort order for this on the frontend
     * @type {number}
     * @memberof MenuItem
     */
    sortOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    taxRate: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    caloriesBase?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    caloriesMax?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    minQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    maxQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    minCartQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    maxCartQuantity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MenuItem
     */
    isAlcohol?: boolean;
    /**
     * Manual toggle for merchants / admins to disable this menu item.
     * @type {boolean}
     * @memberof MenuItem
     */
    isActive?: boolean;
    /**
     * Dynamic check for final item eligibility after final validations such as NFT ownership.
     * @type {boolean}
     * @memberof MenuItem
     */
    isEnabled?: boolean;
    /**
     * Shows item with overlay to tease upcoming release.
     * @type {boolean}
     * @memberof MenuItem
     */
    comingSoon?: boolean;
    /**
     * Highlights item in promotions and featured sections.
     * @type {boolean}
     * @memberof MenuItem
     */
    featured?: boolean;
    /**
     * Shows item as unavailable but not completely disabled.
     * @type {boolean}
     * @memberof MenuItem
     */
    outOfStock?: boolean;
    /**
     * 
     * @type {Array<BusinessServiceAvailability>}
     * @memberof MenuItem
     */
    serviceAvailabilities?: Array<BusinessServiceAvailability>;
    /**
     * 
     * @type {Array<MenuCustomization>}
     * @memberof MenuItem
     */
    customizations?: Array<MenuCustomization>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MenuItem
     */
    nftGroupings?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    chowlyId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    chowlyExternalId?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    oloId?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItem
     */
    oloChainId?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItem
     */
    itsaCheckmateId?: string;
    /**
     * Whether this item is a gift card
     * @type {boolean}
     * @memberof MenuItem
     */
    isGiftCard?: boolean;
    /**
     * Region where the gift card can be redeemed
     * @type {string}
     * @memberof MenuItem
     */
    redeemableRegion?: MenuItemRedeemableRegionEnum;
    /**
     * Whether gift card has fixed or open amounts
     * @type {string}
     * @memberof MenuItem
     */
    denominationType?: MenuItemDenominationTypeEnum;
    /**
     * Available fixed amounts for gift card
     * @type {Array<number>}
     * @memberof MenuItem
     */
    fixedAmounts?: Array<number>;
    /**
     * Minimum amount for open value gift cards
     * @type {number}
     * @memberof MenuItem
     */
    minAmount?: number;
    /**
     * Maximum amount for open value gift cards
     * @type {number}
     * @memberof MenuItem
     */
    maxAmount?: number;
    /**
     * Tillo product identifier
     * @type {string}
     * @memberof MenuItem
     */
    tilloProductId?: string;
    /**
     * Gift card specific image URL
     * @type {string}
     * @memberof MenuItem
     */
    giftCardImageUrl?: string;
    /**
     * Brand name for the gift card
     * @type {string}
     * @memberof MenuItem
     */
    brand?: string;
    /**
     * Our negotiated discount from Tillo (percentage)
     * @type {number}
     * @memberof MenuItem
     */
    ourDiscount?: number;
    /**
     * Fuel rewards for standard users (percentage)
     * @type {number}
     * @memberof MenuItem
     */
    fuelBackStandard?: number;
    /**
     * Enhanced Fuel rewards for Industry Pass holders (percentage)
     * @type {number}
     * @memberof MenuItem
     */
    fuelBackIndustryPass?: number;
    /**
     * XP earned per dollar spent for standard users
     * @type {number}
     * @memberof MenuItem
     */
    xpStandard?: number;
    /**
     * XP earned per dollar for Industry Pass holders
     * @type {number}
     * @memberof MenuItem
     */
    xpIndustryPass?: number;
}

export function MenuItemFromJSON(json: any): MenuItem {
    return MenuItemFromJSONTyped(json, false);
}

export function MenuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'category': json['category'],
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(AssetFromJSON)),
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': json['price'],
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'taxRate': json['taxRate'],
        'caloriesBase': !exists(json, 'caloriesBase') ? undefined : json['caloriesBase'],
        'caloriesMax': !exists(json, 'caloriesMax') ? undefined : json['caloriesMax'],
        'minQuantity': !exists(json, 'minQuantity') ? undefined : json['minQuantity'],
        'maxQuantity': !exists(json, 'maxQuantity') ? undefined : json['maxQuantity'],
        'minCartQuantity': !exists(json, 'minCartQuantity') ? undefined : json['minCartQuantity'],
        'maxCartQuantity': !exists(json, 'maxCartQuantity') ? undefined : json['maxCartQuantity'],
        'isAlcohol': !exists(json, 'isAlcohol') ? undefined : json['isAlcohol'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'comingSoon': !exists(json, 'comingSoon') ? undefined : json['comingSoon'],
        'featured': !exists(json, 'featured') ? undefined : json['featured'],
        'outOfStock': !exists(json, 'outOfStock') ? undefined : json['outOfStock'],
        'serviceAvailabilities': !exists(json, 'serviceAvailabilities') ? undefined : ((json['serviceAvailabilities'] as Array<any>).map(BusinessServiceAvailabilityFromJSON)),
        'customizations': !exists(json, 'customizations') ? undefined : ((json['customizations'] as Array<any>).map(MenuCustomizationFromJSON)),
        'nftGroupings': !exists(json, 'nftGroupings') ? undefined : json['nftGroupings'],
        'chowlyId': !exists(json, 'chowlyId') ? undefined : json['chowlyId'],
        'chowlyExternalId': !exists(json, 'chowlyExternalId') ? undefined : json['chowlyExternalId'],
        'oloId': !exists(json, 'oloId') ? undefined : json['oloId'],
        'oloChainId': !exists(json, 'oloChainId') ? undefined : json['oloChainId'],
        'itsaCheckmateId': !exists(json, 'itsaCheckmateId') ? undefined : json['itsaCheckmateId'],
        'isGiftCard': !exists(json, 'isGiftCard') ? undefined : json['isGiftCard'],
        'redeemableRegion': !exists(json, 'redeemableRegion') ? undefined : json['redeemableRegion'],
        'denominationType': !exists(json, 'denominationType') ? undefined : json['denominationType'],
        'fixedAmounts': !exists(json, 'fixedAmounts') ? undefined : json['fixedAmounts'],
        'minAmount': !exists(json, 'minAmount') ? undefined : json['minAmount'],
        'maxAmount': !exists(json, 'maxAmount') ? undefined : json['maxAmount'],
        'tilloProductId': !exists(json, 'tilloProductId') ? undefined : json['tilloProductId'],
        'giftCardImageUrl': !exists(json, 'giftCardImageUrl') ? undefined : json['giftCardImageUrl'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'ourDiscount': !exists(json, 'ourDiscount') ? undefined : json['ourDiscount'],
        'fuelBackStandard': !exists(json, 'fuelBackStandard') ? undefined : json['fuelBackStandard'],
        'fuelBackIndustryPass': !exists(json, 'fuelBackIndustryPass') ? undefined : json['fuelBackIndustryPass'],
        'xpStandard': !exists(json, 'xpStandard') ? undefined : json['xpStandard'],
        'xpIndustryPass': !exists(json, 'xpIndustryPass') ? undefined : json['xpIndustryPass'],
    };
}

export function MenuItemToJSON(value?: MenuItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'category': value.category,
        'images': value.images === undefined ? undefined : ((value.images as Array<any>).map(AssetToJSON)),
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'sortOrder': value.sortOrder,
        'taxRate': value.taxRate,
        'caloriesBase': value.caloriesBase,
        'caloriesMax': value.caloriesMax,
        'minQuantity': value.minQuantity,
        'maxQuantity': value.maxQuantity,
        'minCartQuantity': value.minCartQuantity,
        'maxCartQuantity': value.maxCartQuantity,
        'isAlcohol': value.isAlcohol,
        'isActive': value.isActive,
        'isEnabled': value.isEnabled,
        'comingSoon': value.comingSoon,
        'featured': value.featured,
        'outOfStock': value.outOfStock,
        'serviceAvailabilities': value.serviceAvailabilities === undefined ? undefined : ((value.serviceAvailabilities as Array<any>).map(BusinessServiceAvailabilityToJSON)),
        'customizations': value.customizations === undefined ? undefined : ((value.customizations as Array<any>).map(MenuCustomizationToJSON)),
        'nftGroupings': value.nftGroupings,
        'chowlyId': value.chowlyId,
        'chowlyExternalId': value.chowlyExternalId,
        'oloId': value.oloId,
        'oloChainId': value.oloChainId,
        'itsaCheckmateId': value.itsaCheckmateId,
        'isGiftCard': value.isGiftCard,
        'redeemableRegion': value.redeemableRegion,
        'denominationType': value.denominationType,
        'fixedAmounts': value.fixedAmounts,
        'minAmount': value.minAmount,
        'maxAmount': value.maxAmount,
        'tilloProductId': value.tilloProductId,
        'giftCardImageUrl': value.giftCardImageUrl,
        'brand': value.brand,
        'ourDiscount': value.ourDiscount,
        'fuelBackStandard': value.fuelBackStandard,
        'fuelBackIndustryPass': value.fuelBackIndustryPass,
        'xpStandard': value.xpStandard,
        'xpIndustryPass': value.xpIndustryPass,
    };
}

/**
* @export
* @enum {string}
*/
export enum MenuItemRedeemableRegionEnum {
    US = 'US',
    CA = 'CA',
    UK = 'UK',
    EU = 'EU',
    AU = 'AU',
    GLOBAL = 'GLOBAL'
}
/**
* @export
* @enum {string}
*/
export enum MenuItemDenominationTypeEnum {
    FIXED = 'FIXED',
    OPEN = 'OPEN'
}


